import graceLogo from "@/assets/clients/grace-larissa-faidiga.png.asset.json";
import unimedLogo from "@/assets/clients/unimed-sorocaba.png.asset.json";
import nicholasLogo from "@/assets/clients/nicholas-bueno.png.asset.json";
import fernandaLogo from "@/assets/clients/fernanda-figueiredo.png.asset.json";

/**
 * ClientLogosStrip — faixa de clientes institucionais.
 * Uso de nome e logo autorizado pelos clientes. Sem links, sem claims de
 * recomendação/parceria oficial. Reutilizável (home, /profissionais-saude, /clinicas).
 */

const CLIENTS = [
  {
    src: graceLogo.url,
    alt: "Grace Clinic & Spa by Larissa Faidiga",
    className: "h-8 md:h-10",
  },
  {
    src: unimedLogo.url,
    alt: "Unimed Sorocaba",
    className: "h-9 md:h-11",
  },
  {
    src: nicholasLogo.url,
    alt: "Nicholas Bueno — Terapeuta Corporal",
    className: "h-10 md:h-[52px]",
  },
  {
    src: fernandaLogo.url,
    alt: "Fernanda Figueiredo — Fisioterapia",
    className: "h-9 md:h-11",
  },
];

export const ClientLogosStrip = () => {
  return (
    <section
      aria-label="Clientes institucionais"
      className="border-y border-[#E6E2DC] bg-background py-7"
    >
      <p className="mb-5 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-[#5A6B7F]">
        Presente em clínicas e instituições de saúde
      </p>

      {/* Marquee contínuo (pausa no hover/toque; parado com prefers-reduced-motion) */}
      <div className="client-logos-marquee overflow-hidden">
        <div className="client-logos-track flex w-max items-center gap-16 pr-16">
          {[...CLIENTS, ...CLIENTS].map((client, i) => (
            <img
              key={`${client.alt}-${i}`}
              src={client.src}
              alt={i < CLIENTS.length ? client.alt : ""}
              aria-hidden={i >= CLIENTS.length}
              loading="lazy"
              decoding="async"
              className={`${client.className} w-auto shrink-0 opacity-75 transition-opacity duration-300 hover:opacity-100`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
